import React from 'react';
import './HeroSection.css'; // Import CSS for styling
import logo from '../assets/logo_dark_blue.png'; // Adjust the path as necessary

const HeroSection = () => {
  return (
    <div className="hero-container">
      <video autoPlay loop muted className="hero-video">
        <source src="/video/header_video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="hero-content">
        <h1>Save Your Waters With</h1>
        <img src={logo} alt="Company Logo" className="logo" />

      </div>
    </div>
  );
};

export default HeroSection;
